import React, { useState, useEffect } from "react";
import "../styles/AddImovel.css";

import { useNavigate } from "react-router-dom";

import { storage, db } from "../../firebaseConfig";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { onValue, ref as databaseRef, set, push, get, update } from "firebase/database";

import { Alert, Snackbar, CircularProgress, Backdrop } from "@mui/material";

import imageCompression from "browser-image-compression";

import { buildPublicImovel } from "../../utils/buildPublicImovel";

const AddImovel = () => {

  const navigate = useNavigate();

  const [isSaving, setIsSaving] = useState(false);
  const [cidades, setCidades] = useState([]);
  const [cidadeSelecionada, setCidadeSelecionada] = useState("");
  const [bairros, setBairros] = useState([]);
  const [draggedIndex, setDraggedIndex] = useState(null);

  const [atributosFirebase, setAtributosFirebase] = useState([]);

  const [corretores, setCorretores] = useState([]);

  const [imovelInfo, setImovelInfo] = useState({
    corretor: "",
    codigo: "",
    construtora: "",
    titulo: "",
    modalidade: "",
    cidade: "",
    bairro: "",
    endereco: "",
    referencia: "",
    complemento: "",
    cep: "",
    tipo: "",
    descricao: "",
    descricaoInterna: "",
    status: true,
  });

  const [ownerInfo, setOwnerInfo] = useState({
    nome: "",
    sobrenome: "",
    cpf: "",
    telefone: "",
    birth: "",
    email: "",
    conjuge: "",
  });

  const [caracteristicas, setCaracteristicas] = useState({
    areaTerreno: "",
    areaConstruida: "",
    areaTerrenoH: "",
    banheiros: "",
    lavabos: "",
    suites: "",
    quartos: "",
    vagas: "",
    areaGourmet: "",
    posicao: "",
    sacadas: "",
    salas: "",
    varanda: "",
    pavimentos: "",
    cozinha: "",
    comodos: "",
    areasServico: "",
    copas: "",
    areaPrivativa: "",
    frente: "",
    lateralDireita: "",
    lateralEsquerda: "",
    fundos: "",
  });

  const [informacoesComerciais, setInformacoesComerciais] = useState({
    tipoVenda: "",
    valor: "",
    comissaoPercentual: "",
    comissaoValor: "",
    iptu: "",
    condominio: "",
  });

  const [informacoesAdicionais, setInformacoesAdicionais] = useState({
    chaveImobiliaria: "",
    placa: "",
    exclusivo: "",
    numeroIptu: "",
    numeroMatricula: "",
    codigoDamae: "",
    numeroEnergiaEletrica: "",
    numeroInstalacaoEletrica: "",
    parceria: "",
    nomeParceria: "",
    linkLocalizacao: "",
  });

  const [selectedItems, setSelectedItems] = useState([]);

  const [bookTecnicoFile, setBookTecnicoFile] = useState(null);
  const [bookTecnicoURL, setBookTecnicoURL] = useState("");

  const convertToWebP = async (file) => {
    try {
      const options = {
        fileType: "image/webp",
        initialQuality: 0.8, // 80% qualidade
        maxWidthOrHeight: 1920, // opcional: redimensiona
      };
      const compressedFile = await imageCompression(file, options);
      return compressedFile;
    } catch (error) {
      console.error("Erro ao converter imagem para WEBP:", error);
      return file; // fallback: retorna original se falhar
    }
  };

  const formatCEP = (cep) => {
    let cleanCep = cep.replace(/\D/g, "");
    if (cleanCep.length > 8) {
      cleanCep = cleanCep.slice(0, 8);
    }
    return cleanCep.replace(/^(\d{2})(\d{3})(\d{3})$/, "$1.$2-$3");
  };

  const formatBRL = (valor) => {
    let cleanValue = valor.replace(/\D/g, "");
    if (cleanValue === "") return "";
    let formattedValue = (parseFloat(cleanValue) / 100).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
      }
    );
    return formattedValue;
  };

  const formatPercentage = (valor) => {
    let cleanValue = valor.replace(/\D/g, "");
    let numericValue = Math.min(parseInt(cleanValue, 10) || 0, 100);
    return `${numericValue}%`;
  };

  const calcularComissao = (valor, percentual) => {
    let valorNumerico = parseFloat(valor.replace(/\D/g, "")) / 100 || 0;
    let percentualNumerico =
      parseFloat(percentual.replace(/\D/g, "")) / 100 || 0;
    let comissao = valorNumerico * percentualNumerico;
    return formatBRL(comissao.toFixed(2));
  };

  function formatNumber(value) {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 11);
    return value
      .replace(/^(\d{2})(\d{5})(\d{0,4})$/, "($1) $2-$3")
      .replace(/^(\d{2})(\d{4})(\d{0,4})$/, "($1) $2-$3");
  }

  function formatDate(value) {
    value = value.replace(/\D/g, "");
    value = value.slice(0, 8);
    return value.replace(/^(\d{2})(\d{2})(\d{0,4})$/, "$1/$2/$3");
  }

  function formatCPForCNPJ(value) {
    value = value.replace(/\D/g, ""); // Remove caracteres não numéricos

    if (value.length <= 11) {
      // CPF: XXX.XXX.XXX-XX
      return value.replace(/^(\d{3})(\d{3})(\d{3})(\d{0,2})$/, "$1.$2.$3-$4");
    } else {
      // CNPJ: XX.XXX.XXX/XXXX-XX
      return value.replace(
        /^(\d{2})(\d{3})(\d{3})(\d{4})(\d{0,2})$/,
        "$1.$2.$3/$4-$5"
      );
    }
  }

  const handleChange = (e, section, setSectionState) => {
    const { name, value } = e.target;

    let realValue = value;

    if (name === "cep") {
      realValue = formatCEP(realValue);
    } else if (
      ["valor", "comissaoValor", "iptu", "condominio"].includes(name)
    ) {
      realValue = formatBRL(realValue);
    } else if (name === "comissaoPercentual") {
      realValue = formatPercentage(realValue);
    } else if (name === "construtora" && value === "false") {
      setSectionState((prevState) => ({
        ...prevState,
        titulo: "",
      }));
    } else if (name === "cpf") {
      realValue = formatCPForCNPJ(realValue);
    } else if (name === "telefone" || name === "telefone2") {
      realValue = formatNumber(realValue);
    } else if (name === "birth") {
      realValue = formatDate(realValue);
    }

    const camposDecimais = [
      "areaTerrenoH",
      "areaConstruida",
      "areaTerreno",
      "frente",
      "fundos",
      "lateralDireita",
      "lateralEsquerda",
    ];

    if (
      setSectionState === setCaracteristicas &&
      camposDecimais.includes(name)
    ) {
      realValue = realValue.replace(/[^0-9.,]/g, "");
    }

    if (setSectionState === setInformacoesComerciais) {
      setInformacoesComerciais((prevState) => {
        const updatedState = { ...prevState, [name]: realValue };

        if (updatedState.valor && updatedState.comissaoPercentual) {
          updatedState.comissaoValor = calcularComissao(
            updatedState.valor,
            updatedState.comissaoPercentual
          );
        }

        return updatedState;
      });
    } else {
      setSectionState((prevState) => ({
        ...prevState,
        [name]: realValue,
      }));
    }
  };

  useEffect(() => {
    const atributosRef = databaseRef(db, "atributos");
    onValue(atributosRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const listaAtributos = Object.values(data).sort((a, b) =>
          a.localeCompare(b)
        );
        setAtributosFirebase(listaAtributos);
      } else {
        setAtributosFirebase([]);
      }
    });
  }, []);

  useEffect(() => {
    const corretorRef = databaseRef(db, "corretores/");
    onValue(corretorRef, (snapshot) => {
      const data = snapshot.val();

      if (data) {
        const allCorretores = Object.values(data).reverse();

        setCorretores(allCorretores);
      } else {
        setCorretores([]);
      }
    });
  }, []);

  useEffect(() => {
    const fetchCidades = async () => {
      try {
        const locRef = databaseRef(db, "loc/cidades/");
        const snapshot = await get(locRef);
        if (snapshot.exists()) {
          const data = snapshot.val();
          const cidadeArray = Object.keys(data)
            .map((key) => ({
              id: key,
              nome: data[key].nome,
              bairros: data[key].bairros
                ? Object.values(data[key].bairros)
                : [],
            }))
            .sort((a, b) => a.nome.localeCompare(b.nome));
          setCidades(cidadeArray);
        }
      } catch (error) {
        console.error("Erro ao buscar cidades:", error);
      }
    };
    fetchCidades();
  }, []);

  const handleBookTecnicoChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type === "application/pdf") {
      setBookTecnicoFile(file);
    } else {
      setAlertMessage("Selecione um arquivo PDF válido.");
      setAlertType("error");
      setOpenAlert(true);
    }
  };

  const handleRemoveBookTecnico = () => {
    setBookTecnicoFile(null);
    setBookTecnicoURL("");
  };

  const handleCidadeChange = (e) => {
    const cidadeId = e.target.value;
    setCidadeSelecionada(cidadeId);

    const cidadeSelecionada = cidades.find((c) => c.id === cidadeId);
    setBairros(cidadeSelecionada ? cidadeSelecionada.bairros : []);

    setImovelInfo((prevState) => ({
      ...prevState,
      cidade: cidadeSelecionada ? cidadeSelecionada.nome : "",
      bairro: "", // Reseta o bairro ao mudar a cidade
    }));
  };

  const handleBairroChange = (e) => {
    setImovelInfo((prevState) => ({
      ...prevState,
      bairro: e.target.value, // Confirme que está usando "bairro" e não "bairros"
    }));
  };

  const handleCheckboxChange = (event) => {
    const { value, checked } = event.target;
    setSelectedItems((prevSelected) =>
      checked
        ? [...prevSelected, value]
        : prevSelected.filter((item) => item !== value)
    );
  };

  const [selectedImages, setSelectedImages] = useState([]);
  const MAX_IMAGES = 100;

  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [openAlert, setOpenAlert] = useState(false);

  const handleCloseAlert = () => {
    setOpenAlert(false);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    if (selectedImages.length + files.length > MAX_IMAGES) {
      alert(`Você pode adicionar no máximo ${MAX_IMAGES} imagens.`);
      return;
    }

    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setSelectedImages((prevImages) => [...prevImages, ...newImages]);
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handleSave = async () => {
    setIsSaving(true);

    try {
      await new Promise((resolve) => setTimeout(resolve, 2000)); // Simulação de espera

      const imoveisRef = databaseRef(db, "imoveis/");
      const snapshot = await get(imoveisRef);

      let novoCodigo = 1;
      if (snapshot.exists()) {
        const imoveis = snapshot.val();
        const codigos = Object.values(imoveis)
          .map((imovel) => parseInt(imovel.imovelInfo.codigo, 10))
          .filter((num) => !isNaN(num))
          .sort((a, b) => a - b);

        if (codigos.length > 0) {
          const ultimoCodigo = codigos[codigos.length - 1];
          novoCodigo = ultimoCodigo + 1;
        }
      }

      const camposObrigatorios = {
        imovelInfo: [
          "corretor",
          "construtora",
          "titulo",
          "modalidade",
          "cidade",
          "bairro",
          "endereco",
          "tipo",
          "descricao",
        ],
        ownerInfo: ["nome", "sobrenome", "cpf", "telefone"],
        informacoesComerciais: [
          "tipoVenda",
          "valor",
          "comissaoPercentual",
          "comissaoValor",
        ],
        informacoesAdicionais: [
          "chaveImobiliaria",
          "placa",
          "exclusivo",
          "parceria",
          "linkLocalizacao",
        ],
      };

      const camposVazios = [];

      Object.entries(camposObrigatorios).forEach(([section, fields]) => {
        fields.forEach((campo) => {
          if (!eval(section)[campo]?.trim()) {
            camposVazios.push(campo);
          }
        });
      });

      if (camposVazios.length > 0) {
        setAlertMessage(
          `Preencha todos os campos obrigatórios: ${camposVazios.join(", ")}`
        );
        setAlertType("error");
        setOpenAlert(true);
        setIsSaving(false);
        return;
      }

      if (selectedImages.length < 3) {
        setAlertMessage("Adicione pelo menos 3 imagens.");
        setAlertType("error");
        setOpenAlert(true);
        setIsSaving(false);
        return;
      }

      const newImovelRef = push(imoveisRef);
      const newImovelKey = newImovelRef.key;

      let imagesLinks = new Array(selectedImages.length); // Mantém a ordem original

      const uploadImage = async (file, index) => {
        return new Promise(async (resolve, reject) => {
          try {
            // converte antes de subir
            const webpFile = await convertToWebP(file.file);

            const fileRef = storageRef(
              storage,
              `imoveis/${newImovelKey}/${index}.webp`
            );
            const uploadTask = uploadBytesResumable(fileRef, webpFile);

            uploadTask.on(
              "state_changed",
              (snapshot) => {
                const progress =
                  (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
                console.log(
                  `Upload da imagem ${index + 1} está ${progress}% concluído`
                );
              },
              (error) => {
                console.error(`Erro no upload da imagem ${index + 1}:`, error);
                reject(error);
              },
              async () => {
                const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                imagesLinks[index] = downloadURL;
                resolve();
              }
            );
          } catch (error) {
            reject(error);
          }
        });
      };


      for (let i = 0; i < selectedImages.length; i++) {
        await uploadImage(selectedImages[i], i);
      }

      let bookURL = "";

      if (bookTecnicoFile) {
        const pdfRef = storageRef(storage, `imoveis/${newImovelKey}/bookTecnico.pdf`);
        const uploadPDF = uploadBytesResumable(pdfRef, bookTecnicoFile);

        await new Promise((resolve, reject) => {
          uploadPDF.on(
            "state_changed",
            null,
            (error) => {
              console.error("Erro ao enviar o Book Técnico:", error);
              reject(error);
            },
            async () => {
              bookURL = await getDownloadURL(uploadPDF.snapshot.ref);
              resolve();
            }
          );
        });
      }

      // Escrita por caminhos relativos (não um set() do nó inteiro): assim, se a
      // Function de watermark já tiver marcado `control/watermarked` antes deste
      // ponto (imagem processada mais rápido que o restante do cadastro), essa
      // chamada não apaga o valor — só toca as chaves explicitadas abaixo.
      await update(newImovelRef, {
        "control/available": true,
        "control/done": false,
        "control/id": newImovelKey,
        imovelInfo: { ...imovelInfo, codigo: novoCodigo.toString() },
        ownerInfo,
        caracteristicas,
        informacoesComerciais,
        informacoesAdicionais,
        selectedItems,
        imagesLinks,
        bookTecnicoURL: bookURL || "",
      });

      // Relê o nó já persistido (read-after-write) para publicar com o estado
      // real do banco, e não com a memória local (que nunca viu um eventual
      // `control.watermarked` gravado pela Function nesse meio-tempo).
      const freshSnap = await get(newImovelRef);
      const freshImovel = freshSnap.val() || {};

      const publicData = buildPublicImovel(newImovelKey, freshImovel);
      await set(databaseRef(db, `imoveisPublicos/${newImovelKey}`), publicData);

      setAlertMessage(`Imóvel cadastrado com sucesso! Código: ${novoCodigo}`);
      setAlertType("success");
      setOpenAlert(true);

      setTimeout(() => {
        navigate("/panel/lista-imoveis"); // Redireciona para a lista de imóveis
      }, 2000); // Aguarda 2 segundos para exibir o alerta antes de redirecionar

      setImovelInfo({
        corretor: "",
        construtora: "",
        titulo: "",
        modalidade: "",
        cidades: "",
        bairros: "",
        endereco: "",
        complemento: "",
        referencia: "",
        cep: "",
        tipo: "",
        descricao: "",
        descricaoInterna: "",
        status: true,
      });
      setBookTecnicoFile(null);
      setBookTecnicoURL("");
      setOwnerInfo({
        nome: "",
        sobrenome: "",
        cpf: "",
        telefone: "",
        telefone2: "",
        birth: "",
        email: "",
        conjuge: "",
      });
      setCaracteristicas({
        areaTerreno: "",
        areaConstruida: "",
        areaTerrenoH: "",
        banheiros: "",
        lavabos: "",
        suites: "",
        quartos: "",
        vagas: "",
        areaGourmet: "",
        posicao: "",
        sacadas: "",
        salas: "",
        varanda: "",
        pavimentos: "",
        cozinha: "",
        comodos: "",
        areasServico: "",
        copas: "",
        areaPrivativa: "",
        frente: "",
        lateralDireita: "",
        lateralEsquerda: "",
        fundos: "",
      });
      setInformacoesComerciais({
        tipoVenda: "",
        valor: "",
        comissaoPercentual: "",
        comissaoValor: "",
        iptu: "",
        condominio: "",
      });
      setInformacoesAdicionais({
        chaveImobiliaria: "",
        placa: "",
        exclusivo: "",
        numeroIptu: "",
        numeroMatricula: "",
        codigoDamae: "",
        numeroEnergiaEletrica: "",
        numeroInstalacaoEletrica: "",
        parceria: "",
        nomeParceria: "",
        linkLocalizacao: "",
      });
      setSelectedItems([]);
      setSelectedImages([]);
    } catch (error) {
      console.error("Erro ao salvar imóvel:", error);
      setAlertMessage("Erro ao salvar imóvel. Tente novamente.");
      setAlertType("error");
      setOpenAlert(true);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="add-page">
      <h1>Adicionar Imóvel</h1>
      <div className="containerAddImovel">
        <h3>Informações Básicas</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Corretor</label>
            <select
              name="corretor"
              value={imovelInfo.corretor}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
            >
              <option value="" disabled>
                Selecione um corretor
              </option>
              {Object.values(corretores).map((corretor, index) => (
                <option key={index} value={corretor.id}>
                  {corretor.nome}
                </option>
              ))}
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Tipo do Imóvel</label>
            <select
              name="tipo"
              value={imovelInfo.tipo}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="Casa">CASA</option>
              <option value="Apartamento">APARTAMENTO</option>
              <option value="Lote">LOTE</option>
              <option value="Pousada">POUSADA</option>
              <option value="Sitio">SÍTIO</option>
              <option value="Fazenda">FAZENDA</option>
              <option value="Terreno">TERRENO</option>
              <option value="Galpão">GALPÃO</option>
              <option value="Sala Comercial">SALA COMERCIAL</option>
              <option value="Imovel Comercial">IMÓVEL COMERCIAL</option>
              <option value="Imovel na Planta">IMÓVEL NA PLANTA</option>
              <option value="Chale">CHALÉ</option>
              <option value="Kitnet">KITNET</option>
              <option value="Em Construcao">EM CONSTRUÇÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Incorporação</label>
            <select
              name="construtora"
              value={imovelInfo.construtora}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Título Imóvel</label>
            <input
              name="titulo"
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              value={imovelInfo.titulo}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Modalidade</label>
            <select
              name="modalidade"
              value={imovelInfo.modalidade}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="Venda">VENDA</option>
              <option value="Aluguel">ALUGUEL</option>
              <option value="Temporada">TEMPORADA</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cidade (MG)</label>
            <select
              name="cidade"
              className="selectInputText"
              value={cidadeSelecionada}
              onChange={handleCidadeChange}
            >
              <option value="" disabled>
                Selecione uma cidade
              </option>
              {cidades.map((cidades) => (
                <option key={cidades.id} value={cidades.id}>
                  {cidades.nome}
                </option>
              ))}
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Bairro</label>
            <select
              name="bairro"
              className="selectInputText"
              value={imovelInfo.bairro} // Use "bairro" e não "bairros"
              onChange={handleBairroChange}
              disabled={!cidadeSelecionada}
            >
              <option value="" disabled>
                Selecione um bairro
              </option>
              {bairros.map((bairro, index) => (
                <option key={index} value={bairro}>
                  {bairro}
                </option>
              ))}
            </select>
          </div>

          <div className="input-groupText">
            <label className="labelText">Endereço do Imóvel</label>
            <input
              name="endereco"
              value={imovelInfo.endereco}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Complemento</label>
            <input
              name="complemento"
              value={imovelInfo.complemento}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Referência</label>
            <input
              name="referencia"
              value={imovelInfo.referencia}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CEP do Imóvel</label>
            <input
              name="cep"
              value={imovelInfo.cep}
              onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Informações do Proprietário</h3>
        <div className="containerOne">

          <div className="input-groupText">
            <label className="labelText">Nome</label>
            <input
              name="nome"
              value={ownerInfo.nome}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Sobrenome</label>
            <input
              name="sobrenome"
              value={ownerInfo.sobrenome}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CPF/CNPJ</label>
            <input
              name="cpf"
              value={ownerInfo.cpf}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
              maxLength="18" // Limita ao tamanho máximo do CNPJ formatado
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Data de Nascimento</label>
            <input
              name="birth"
              value={ownerInfo.birth}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Telefone</label>
            <input
              name="telefone"
              value={ownerInfo.telefone}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cônjuge</label>
            <input
              name="conjuge"
              value={ownerInfo.conjuge}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Telefone Cônjuge</label>
            <input
              name="telefone2"
              value={ownerInfo.telefone2}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Email do Proprietário</label>
            <input
              name="email"
              value={ownerInfo.email}
              onChange={(e) => handleChange(e, ownerInfo, setOwnerInfo)}
              className="inputText"
              type="email"
            />
          </div>
        </div>

        <h3>Caracteristicas do Imóvel</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Área terreno (m²)</label>
            <input
              name="areaTerreno"
              value={caracteristicas.areaTerreno}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área construída (m²)</label>
            <input
              name="areaConstruida"
              value={caracteristicas.areaConstruida}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área Terreno HECTARE (He)</label>
            <input
              name="areaTerrenoH"
              value={caracteristicas.areaTerrenoH}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Banheiros</label>
            <input
              name="banheiros"
              value={caracteristicas.banheiros}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lavabos</label>
            <input
              name="lavabos"
              value={caracteristicas.lavabos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Suítes</label>
            <input
              name="suites"
              value={caracteristicas.suites}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Quartos</label>
            <input
              name="quartos"
              value={caracteristicas.quartos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Vagas</label>
            <input
              name="vagas"
              value={caracteristicas.vagas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Posição</label>
            <input
              name="posicao"
              value={caracteristicas.posicao}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área Gourmet</label>
            <select
              name="areaGourmet"
              value={caracteristicas.areaGourmet}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Sacadas</label>
            <input
              name="sacadas"
              value={caracteristicas.sacadas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Salas</label>
            <input
              name="salas"
              value={caracteristicas.salas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Varanda</label>
            <input
              name="varanda"
              value={caracteristicas.varanda}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Pavimentos</label>
            <input
              name="pavimentos"
              value={caracteristicas.pavimentos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Cozinha</label>
            <input
              name="cozinha"
              value={caracteristicas.cozinha}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Áreas de serviço</label>
            <input
              name="areasServico"
              value={caracteristicas.areasServico}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Copas</label>
            <input
              name="copas"
              value={caracteristicas.copas}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Área privativa</label>
            <input
              name="areaPrivativa"
              value={caracteristicas.areaPrivativa}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lateral Direita</label>
            <input
              name="lateralDireita"
              value={caracteristicas.lateralDireita}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Lateral Esquerda</label>
            <input
              name="lateralEsquerda"
              value={caracteristicas.lateralEsquerda}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Frente</label>
            <input
              name="frente"
              value={caracteristicas.frente}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Fundos</label>
            <input
              name="fundos"
              value={caracteristicas.fundos}
              onChange={(e) =>
                handleChange(e, caracteristicas, setCaracteristicas)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Atributos</h3>
        <div className="containerOne">
          <div className="atributosContainer">
            {atributosFirebase.map((item, index) => (
              <div key={index}>
                <input
                  style={{ marginTop: "10px" }}
                  type="checkbox"
                  id={item}
                  value={item}
                  checked={selectedItems.includes(item)}
                  onChange={handleCheckboxChange}
                />
                <label htmlFor={item}>{item}</label>
              </div>
            ))}
          </div>
        </div>

        <h3>Informações Comerciais</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Tipo de Venda</label>
            <select
              name="tipoVenda"
              value={informacoesComerciais.tipoVenda}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="a partir de">A PARTIR DE</option>
              <option value="valor">VALOR</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor</label>
            <input
              name="valor"
              value={informacoesComerciais.valor}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Comissão %</label>
            <input
              name="comissaoPercentual"
              value={informacoesComerciais.comissaoPercentual}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Comissão R$</label>
            <input
              name="comissaoValor"
              value={informacoesComerciais.comissaoValor}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor do IPTU</label>
            <input
              name="iptu"
              value={informacoesComerciais.iptu}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Valor do Condomínio</label>
            <input
              name="condominio"
              value={informacoesComerciais.condominio}
              onChange={(e) =>
                handleChange(e, informacoesComerciais, setInformacoesComerciais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Informações Adicionais</h3>
        <div className="containerOne">
          <div className="input-groupText">
            <label className="labelText">Chave na imobiliária</label>
            <select
              name="chaveImobiliaria"
              value={informacoesAdicionais.chaveImobiliaria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Possui Placa</label>
            <select
              name="placa"
              value={informacoesAdicionais.placa}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Exclusivo</label>
            <select
              name="exclusivo"
              value={informacoesAdicionais.exclusivo}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N° IPTU</label>
            <input
              name="numeroIptu"
              value={informacoesAdicionais.numeroIptu}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N° MATRÍCULA</label>
            <input
              name="numeroMatricula"
              value={informacoesAdicionais.numeroMatricula}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">CÓD. ÁGUA</label>
            <input
              name="codigoDamae"
              value={informacoesAdicionais.codigoDamae}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N°. ENERGIA ELÉTRICA</label>
            <input
              name="numeroEnergiaEletrica"
              value={informacoesAdicionais.numeroEnergiaEletrica}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">N°. INSTALAÇÃO ELÉTRICA</label>
            <input
              name="numeroInstalacaoEletrica"
              value={informacoesAdicionais.numeroInstalacaoEletrica}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="number"
              min="0"
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Parceria</label>
            <select
              name="parceria"
              value={informacoesAdicionais.parceria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="selectInputText"
              type="text"
            >
              <option value="" disabled>
                Selecione uma opção
              </option>
              <option value="true">SIM</option>
              <option value="false">NÃO</option>
            </select>
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Nome Parceria</label>
            <input
              name="nomeParceria"
              value={informacoesAdicionais.nomeParceria}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
              disabled={informacoesAdicionais.parceria !== "true"}
            />
            <div></div>
          </div>

          <div className="input-groupText">
            <label className="labelText">Link de Localização</label>
            <input
              name="linkLocalizacao"
              value={informacoesAdicionais.linkLocalizacao}
              onChange={(e) =>
                handleChange(e, informacoesAdicionais, setInformacoesAdicionais)
              }
              className="inputText"
              type="text"
            />
            <div></div>
          </div>
        </div>

        <h3>Galeria de Fotos</h3>
        <div className="containerOne">
          <input
            type="file"
            accept="image/png, image/jpeg, image/jpg"
            multiple
            onChange={handleImageChange}
            disabled={selectedImages.length >= MAX_IMAGES}
          />
          <p>
            {selectedImages.length} / {MAX_IMAGES} imagens selecionadas
          </p>

          <div className="gallery-preview">
            {selectedImages.map((img, index) => (
              <div
                key={index}
                className={`image-preview ${draggedIndex === index ? "dragging" : ""
                  }`}
                draggable
                onDragStart={() => setDraggedIndex(index)}
                onDragOver={(e) => e.preventDefault()}
                onDrop={() => {
                  const newImages = [...selectedImages];
                  const draggedItem = newImages[draggedIndex];
                  newImages.splice(draggedIndex, 1);
                  newImages.splice(index, 0, draggedItem);
                  setSelectedImages(newImages);
                }}
              >
                <img src={img.preview} alt={`Preview ${index}`} />
                <button type="button" onClick={() => handleRemoveImage(index)}>
                  Remover
                </button>
              </div>
            ))}
          </div>
        </div>

        <h3>Book Técnico (PDF)</h3>
        <div className="containerOne">
          <input
            type="file"
            accept="application/pdf"
            onChange={handleBookTecnicoChange}
          />

          {bookTecnicoFile && (
            <div className="pdf-preview">
              <p>📄 {bookTecnicoFile.name}</p>
              <button type="button" onClick={handleRemoveBookTecnico}>
                Remover PDF
              </button>
            </div>
          )}
        </div>

        <h3>Descrição do imóvel</h3>
        <div className="containerOne">
          <textarea
            name="descricao"
            className="inputDescricao"
            placeholder="Digite a descrição do imóvel..."
            value={imovelInfo.descricao}
            onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
            rows="10"
          />
        </div>
        <h3>Descrição Interna</h3>
        <div className="containerOne">
          <textarea
            name="descricaoInterna"
            className="inputDescricao"
            placeholder="Digite a descrição interna do imóvel..."
            value={imovelInfo.descricaoInterna}
            onChange={(e) => handleChange(e, imovelInfo, setImovelInfo)}
            rows="10"
          />
        </div>
      </div>
      <br />
      <br />

      <button className="float-save" onClick={handleSave}>
        ADICIONAR IMÓVEL
      </button>

      <Backdrop sx={{ color: "#fff", zIndex: 1300 }} open={isSaving}>
        <CircularProgress color="inherit" />
        <p style={{ marginLeft: "10px", fontSize: "18px" }}>Salvando...</p>
      </Backdrop>

      <Snackbar
        open={openAlert}
        autoHideDuration={8000}
        onClose={handleCloseAlert}
      >
        <Alert
          onClose={handleCloseAlert}
          severity={alertType}
          sx={{ width: "100%" }}
        >
          {alertMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default AddImovel;
